/** Production FastAPI host (Swagger at https://admin.mont2academy.com/docs). */
export const PRODUCTION_BACKEND_URL = "https://admin.mont2academy.com";

/** Production Angular LMS / admin panel host. */
export const PRODUCTION_ADMIN_URL = "https://admin.mont2academy.com";

const LOCAL_BACKEND_URL = "http://localhost:4000";
const LOCAL_ADMIN_URL = "http://localhost:4200";

function isMont2Hostname(hostname: string): boolean {
  return (
    hostname === "mont2academy.com" ||
    hostname === "www.mont2academy.com" ||
    hostname === "dev.mont2academy.com" ||
    hostname.endsWith(".mont2academy.com")
  );
}

/**
 * API base URL for browser + server fetches.
 * Prefer NEXT_PUBLIC_BACKEND_URL; never fall back to localhost on mont2academy hosts.
 */
export function getBackendUrl(): string {
  const fromEnv = process.env.NEXT_PUBLIC_BACKEND_URL?.trim().replace(/\/$/, "");
  if (fromEnv && !isLocalhostUrl(fromEnv)) {
    return fromEnv;
  }

  if (typeof window !== "undefined" && isMont2Hostname(window.location.hostname)) {
    return PRODUCTION_BACKEND_URL;
  }

  // Env pointed at localhost but we're building/serving for production
  if (process.env.NODE_ENV === "production" && (!fromEnv || isLocalhostUrl(fromEnv))) {
    return PRODUCTION_BACKEND_URL;
  }

  return fromEnv || LOCAL_BACKEND_URL;
}

export function getAdminUrl(): string {
  const fromEnv = process.env.NEXT_PUBLIC_ADMIN_URL?.trim().replace(/\/$/, "");
  if (fromEnv && !isLocalhostUrl(fromEnv)) {
    return fromEnv;
  }

  if (typeof window !== "undefined" && isMont2Hostname(window.location.hostname)) {
    return PRODUCTION_ADMIN_URL;
  }

  if (process.env.NODE_ENV === "production" && (!fromEnv || isLocalhostUrl(fromEnv))) {
    return PRODUCTION_ADMIN_URL;
  }

  return fromEnv || LOCAL_ADMIN_URL;
}

function isLocalhostUrl(url: string): boolean {
  try {
    const { hostname } = new URL(url);
    return hostname === "localhost" || hostname === "127.0.0.1";
  } catch {
    return url.includes("localhost") || url.includes("127.0.0.1");
  }
}
